import React from "react";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const IconCards = ({ width = "24px", height = "24px", fill = "#000" }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke={fill} strokeWidth="2"/>
    <line x1="3" y1="10" x2="21" y2="10" stroke={fill} strokeWidth="2"/>
  </svg>
);

export default IconCards;